import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getFavoritesByProvider',
  standalone: true,
})
export class GetFavoritesByProvider implements PipeTransform {
  transform(
    collection: any[] | null,
    provider: 'booking.com' | 'occasion_genius' | 'viator',
  ): any[] {
    if (!collection || !collection.length) return [];
    return collection.filter((item) => item.provider === provider).filter((item => item.additionalData !== null));
  }
}
